import { QuoteOrderTypeShippingInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { QuoteShippingModelType, QuoteShippingTypePriceInversed } from '@teinor/erp/types/company/order/quote/quoteShipping'
import { useMemo } from 'react'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import { parseAddressToOneLine } from '../../../../../../../utils/globals/address'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { getCurrencySymbol, prepareVatTag } from '../../../../../../../utils/globals/price'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import { QuoteOrderShippingModelTypeExtended } from '../QuoteStepHeaderShipping'
import useOrderShippingTypePrice from '../../../../../../../utils/hooks/orders/useOrderShippingTypePrice'
import useOrderTypeShippingDict from '../../../../../../../utils/hooks/orders/useOrderTypeShippingDict'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

type QuoteReadOnlyHeaderShippingProps = InputTableLeftTabsProps & QuoteReadOnlyHeaderShippingLogicProps & {
}

const QuoteReadOnlyHeaderShipping: React.FC<QuoteReadOnlyHeaderShippingProps> = ({ headerData, handleChange}) => {
    const {t} = useTwinTranslation()
    const { dictTypeShipping, dictTypePrice, memorizedAddress  } = useQuoteReadOnlyHeaderShippingLogic({ headerData })
    const basicElements : FormElement<keyof QuoteShippingModelType | 'typeShipping' > [] = []
    const extraElements: FormElement<keyof QuoteShippingModelType>[] = []
    basicElements.push(
        {
            name: 'typeShipping',
            component: 'Custom',
            render: () => <ITHeaderText label={t('typeShipping', 'Tipo de envío')} value={dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} className={returnClassOfSpanTemplate(2)} />
        }
    )
    if (headerData?.OrderShippingId && !headerData.typeShipping) {
        if (headerData.typeShipping === QuoteOrderTypeShippingInversed['sendToCustomer']){
            basicElements.push(
                {
                    name: 'ShippingAddressRelationId',
                    component: 'Custom',
                    render: ({ value, extraProps }) => <ITHeaderText label={t('shippingAddress', 'Dirección de envio')} value={memorizedAddress} className={returnClassOfSpanTemplate(2)} />,
                    extraProps: { memorizedAddress }
                },
                {
                    name: 'ShippingServiceId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('shippingServices', 'Servicio de Transportista')} value={headerData?.OrderShipping?.ShippingService?.ShippingCompany?.name + ' - ' + headerData?.OrderShipping?.ShippingService?.name} className={returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'customerPays',
                    component: 'Custom',
                    render: ({ value }) =>{ 
                        return (
                            String(value) === 'true' ?  
                                <ITHeaderText label={t('postage', 'Portes')} value={t('postageDue', 'Portes debidos')} className={returnClassOfSpanTemplate(2)} />
                                : null
                        )
                    },
                },
                {
                    name: 'numberPackages',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('numberPackages', 'Nº bultos')} value={value} className={returnClassOfSpanTemplate(1)} />,
                },
            )
            if (!headerData?.OrderShipping?.customerPays){
                extraElements.push(
                    {
                    name: 'typePrice',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('shippingCalculationS', 'Cálculo trans.')} value={dictTypePrice[parseInt(String(value))]?.name} className={returnClassOfSpanTemplate(1)} />,
                    }
                )
                if (headerData?.OrderShipping?.typePrice === QuoteShippingTypePriceInversed['introducePrice'] ){
                    extraElements.push(
                        {
                            name: headerData.OrderShipping.priceVatIncluded ? 'finalPriceWithTax' : 'initialPriceWithoutTax',
                            component: 'Custom',
                            render: ({ value }) => <ITHeaderText label={t('priceToCustomer', 'Precio cliente')} value={value + getCurrencySymbol(headerData.CurrencyId) + ' - ' + prepareVatTag(headerData?.OrderShipping?.priceVatIncluded, t) } className={returnClassOfSpanTemplate(1)} />
                        }
                    )
                }
            }
            extraElements.push(
                {
                    name: 'weight',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('weight', 'Peso')} value={(value === '0' || value === undefined ? '-' : value) + ' ' + t('kg', 'kg')} className={returnClassOfSpanTemplate(1)} />
                }
            )
        }
    }
    const sections: FormRender<QuoteOrderShippingModelTypeExtended> = [
        {
            cols: 2,
            elements: [
                ...basicElements,
                ...extraElements,
                
            ]
        }
    ]
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData?.OrderShipping} />
    )
}


interface QuoteReadOnlyHeaderShippingLogicProps {
    headerData: TwinDictionary
}

const useQuoteReadOnlyHeaderShippingLogic = ({ headerData}: QuoteReadOnlyHeaderShippingLogicProps) => {
    const memorizedAddress = useMemo(() => parseAddressToOneLine(headerData?.OrderShipping?.ShippingAddressRelation), [headerData?.OrderShipping?.ShippingAddressRelation])
    const dictTypeShipping = useOrderTypeShippingDict()

    const dictTypePrice = useOrderShippingTypePrice()

    return { dictTypeShipping, dictTypePrice, memorizedAddress }
}

export default QuoteReadOnlyHeaderShipping